// A module's own page: the sales page when locked (mockup 3), the settings and first-run list when on.
import { Link, useParams } from 'react-router';
import { getModule, moduleState, missingDependencies } from '@tradeview/core';
import { useAuth } from '../auth';
import { Icon } from '../app/Icon';
import { price } from '../lib/price';
import { NotFound } from './NotFound';

export function ModulePage() {
  const { id = '' } = useParams();
  const { session } = useAuth();
  const m = getModule(id);
  if (!m) return <NotFound />;
  const ent = session?.entitlements ?? null;
  const st = moduleState(ent, id);
  const missing = missingDependencies(id, ent);
  const mk = m.manifest.marketing;
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-center justify-between gap-2.5 pt-1.5">
        <Link to="/modules" className="w-9 h-9 rounded-full bg-surface border border-line grid place-items-center" aria-label="Back"><Icon name="back" size={18} /></Link>
        <h2 className="font-disp font-bold text-[26px] leading-none m-0 flex-1 truncate">{m.manifest.name}</h2>
        <span className={`pill pill-nodot ${st === 'locked' ? 'pill-lock' : st === 'trial' ? 'pill-warn' : 'pill-ok'}`}>{st === 'locked' ? 'Not in plan' : st === 'trial' ? 'Trial' : 'On'}</span>
      </div>
      <p className="m-0 font-head font-semibold text-[17px]">{mk.tagline}</p>
      {mk.bullets.map(b => <div key={b} className="flex gap-2.5 items-start text-[14px]"><Icon name="check" size={18} className="text-ok shrink-0 mt-0.5" /><span>{b}</span></div>)}
      <div className="card"><h4 className="lbl m-0 mb-1.5">Good for</h4><span className="text-[14px]">{mk.goodFor}</span></div>
      {m.manifest.dependencies.length > 0 && (
        <div className="card"><h4 className="lbl m-0 mb-1.5">Works with</h4>
          {m.manifest.dependencies.map(d => <div key={d} className="lrow min-h-10"><div className="min-w-0 flex-1"><b className="block font-semibold">{getModule(d)?.manifest.name ?? d}</b><small className="text-muted text-[12.5px]">{missing.includes(d) ? 'Not in plan · needed first' : 'On'}</small></div></div>)}
        </div>
      )}
      <div className="card"><h4 className="lbl m-0 mb-1.5">Price</h4><div className="flex items-baseline gap-1.5 flex-wrap"><span className="font-disp font-bold text-[38px] leading-none">{price(m.manifest.sku)}</span><small className="text-muted text-[13px]">· {m.manifest.sku.trialDays}-day trial · cancel any time</small></div></div>
      {st === 'locked' ? (
        <>
          <button className="btn btn-primary btn-block" disabled title="Billing arrives in Phase 6">Start {m.manifest.sku.trialDays}-day trial</button>
          <button className="btn btn-block" disabled>Add to plan</button>
          <p className="m-0 text-center text-[12.5px] text-muted">Only an owner or office admin can change the plan. Billing arrives in Phase 6.</p>
        </>
      ) : (
        <>
          {m.manifest.onboarding.length > 0 && (
            <div className="card"><h4 className="lbl m-0 mb-1.5">Set up {m.manifest.name}</h4>
              {m.manifest.onboarding.map((s, i) => <div key={i} className="lrow min-h-10"><span className="w-5 h-5 rounded-md border-2 border-line shrink-0" /><div className="min-w-0 flex-1 text-[14px]">{s}</div></div>)}
            </div>
          )}
          <Link to={m.manifest.routes[0].path} className="btn btn-primary btn-block">Open {m.manifest.name}</Link>
        </>
      )}
    </div>
  );
}
